import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-loader',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss']
})
export class LoaderComponent {
  @Input() type: string = 'default'

  get isDefault() {
    return this.type === 'default'
  }

  get isRound() {
    return this.type === 'round'
  }
}
